'use client'

import { useEffect, useState } from 'react'
import { Button } from '@vinted/web-ui'
import { debounce } from 'lodash'
import classNames from 'classnames'
import { ChevronUp24 } from '@vinted/monochrome-icons'

import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

const SCROLL_DEBOUNCE = 250

const BackToTopButton = () => {
  const [isScrollToTopButtonVisible, setIsScrollToTopButtonVisible] = useState(false)
  const containerClassName = classNames('back-to-top-button', {
    'back-to-top-button--visible': isScrollToTopButtonVisible,
  })

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setIsScrollToTopButtonVisible(true)
      } else {
        setIsScrollToTopButtonVisible(false)
      }
    }

    const watchScroll = () => {
      window.addEventListener('scroll', debounce(handleScroll, SCROLL_DEBOUNCE))
    }

    watchScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  return (
    <ShowAtBreakpoint breakpoint="portables">
      <div className={containerClassName}>
        <Button iconName={ChevronUp24} inline onClick={scrollToTop} />
      </div>
    </ShowAtBreakpoint>
  )
}

export default BackToTopButton
